// 藍田倉除了URmart訂單以外訂單合作的物流商
export enum LogisticCarrier {
  WMS = 0, // 倉庫物流
  TCAT = 1, // 黑貓
  HCT = 2, // 新竹物流
  T_POST = 3, // 郵局
  OTHERS = 4, // 其它
  E_CAN = 5, // 宅配通
  TRANS = 6, // 全盛貨運(邱哥)
  SELF_PICKUP = 7, // 自取
  KERRY = 8, // 嘉里大榮
  MAPLE = 9, // 便利帶
  NX = 10, // 日通
  SF_EXPRESS = 11, // 順豐速運
}

export const logisticCarrierOptions = [
  { label: "倉庫物流", value: LogisticCarrier.WMS },
  { label: "黑貓", value: LogisticCarrier.TCAT },
  { label: "新竹物流", value: LogisticCarrier.HCT },
  { label: "郵局", value: LogisticCarrier.T_POST },
  { label: "其它", value: LogisticCarrier.OTHERS },
  { label: "宅配通", value: LogisticCarrier.E_CAN },
  { label: "全盛貨運(邱哥)", value: LogisticCarrier.TRANS },
  { label: "自取", value: LogisticCarrier.SELF_PICKUP },
  { label: "嘉里大榮", value: LogisticCarrier.KERRY },
  { label: "便利帶", value: LogisticCarrier.MAPLE },
  { label: "日通", value: LogisticCarrier.NX },
  { label: "順豐速運", value: LogisticCarrier.SF_EXPRESS },
];
